import React, { useState } from "react";
import images from '../../assets/Services/mobile_app_img/20945447.jpg'
import Frame from '../../assets/Services/mobile_app_img/Frame.png'
import Iot from '../../assets/Services/mobile_app_img/Iot.png'
import family from '../../assets/Services/mobile_app_img/family.png'

import mobile_app_blockchain from '../../assets/Services/mobile_app_img/mobile_app_blockchain.png'

const CoreComponent = () => {
  const [blockChain, setBlockChain] = useState(true);
  const [internet, setInternet] = useState(false);
  const [ar, setAr] = useState(false);
  const [machinelearnig, setMachinelearnig] = useState(false);

  const handleClick = () => {
    setBlockChain(true);
    setInternet(false);
    setAr(false);
    setMachinelearnig(false);
  };
  const handleClick2 = () => {
    setBlockChain(false);
    setInternet(true);
    setAr(false);
    setMachinelearnig(false);
  };
  const handleClick3 = () => {
    setBlockChain(false);
    setInternet(false);
    setAr(true);
    setMachinelearnig(false);
  };
  const handleClick4 = () => {
    setBlockChain(false);
    setInternet(false);
    setAr(false);
    setMachinelearnig(true);
  };

  return (
    <div>
      <div className="d-flex justify-content-center mb-50 flex-wrap">
        <button
          onClick={handleClick}
          className={` px-4 py-3 h1-para ${
            blockChain ? "text-underline-gradient" : ""
          } ${blockChain ? "fw-semibold" : " fw-less"}`}
        >
          Blockchain{" "}
        </button>
        <button
          onClick={handleClick2}
          className={` px-4 py-3  h1-para ${
            internet ? "text-underline-gradient" : ""
          } ${internet ? "fw-semibold" : " fw-less"}`}
        >
          Internet of Things
        </button>
        <button
          onClick={handleClick3}
          className={` px-4 py-3 h1-para ${ar ? "text-underline-gradient" : ""} ${
            ar ? "fw-semibold" : " fw-less"
          }`}
        >
          AR/VR{" "}
        </button>
        <button
          onClick={handleClick4}
          
          className={` px-4 py-3 h1-para ${
            machinelearnig ? "text-underline-gradient" : ""
          }  ${machinelearnig ? "fw-semibold" : " fw-less"}`}
        >
          Machine Learning
        </button>
      </div>
      <div className="row">
        {blockChain && (
          <>
            <div className="col-lg-6">
              <img
                src={mobile_app_blockchain}
                alt=""
              />
            </div>
            <div className="col-lg-6">
              <h3 className="mb-3 h3-heading mt-2 mt-lg-0">Blockchain </h3>

              <p className="h1-para " >
                Blockchain is a digital solution for securing data through
                innovative encryption. At Raiden Labs, we integrate blockchain
                into mobile applications, enhancing security and user
                empowerment. It allows businesses to create transparent, safe,
                and tamper-proof digital records.
              </p>
              <p className="mt-lg-2 mt-2 h1-para" >
                We prioritize blockchain for its valuable features such as
                verifiable ownership, immutable records, secure transactions,
                and smart contracts. Our primary goal is to provide a seamless
                user experience by incorporating innovative on-device security
                and simplifying complex blockchain interactions.
              </p>
            </div>
          </>
        )}
        {internet && (
          <>
            <div className="col-lg-6">
              <img
                src={Iot}
                alt=""
              />
            </div>
            <div className="col-lg-6">
              <h3 className="h3-heading my-2">Internet of Things</h3>

              <p className="h1-para">
             At Raiden, we integrate your mobile app with the Internet of Things. Our service enables your app to seamlessly connect and control smart devices, collecting real-time data to offer powerful insights and remote management capabilities. 
              </p>
              <p className="mt-2 h1-para">We transform the complex world of IoT into a seamless and secure experience, bringing your app to life in the physical world with confidence and ease.</p>
              <p className="mt-2 h1-para" >This gives your company the ability to innovate and streamline processes through intelligent and real-time connectivity. </p>
            </div>
          </>
        )}
        {ar && (
          <>
            <div className="col-lg-6">
              <img
                src={family}
                alt=""
              />
            </div>
            <div className="col-lg-6">
              <h3 className="h3-heading mt-2 mt-lg-0 mb-2"> AR/VR</h3>

              <p className="h1-para ">
                Integrating Augmented Reality (AR) and Virtual Reality (VR) into
                mobile apps enhances user experience by making interactions more
                engaging. AR projects digital content onto the real world,
                turning everyday spaces into interactive settings, while VR
                immerses users in fully simulated environments.
              </p>
              <p className="mt-2 h1-para">
                This allows users to virtually interact with products, undergo
                hands-on training, and explore captivating digital worlds.
                Ultimately, these technologies create deeper connections and
                memorable experiences, raising the standard for mobile
                engagement.
              </p>
            </div>
          </>
        )}
        {machinelearnig && (
          <>
            <div className="col-lg-6">
              <img
                src={Frame}
                alt=""
              />
            </div>
            <div className="col-lg-6">
              <h3 className="h3-heading my-2"> Machine Learning</h3>

              <p className="h3-para ">
                Our machine learning service empowers your mobile applications
                with advanced intelligence and adaptability. We integrate
                features that enable your app to learn from user behavior,
                ensuring continuous improvement and customized usage.{" "}
              </p>
              <p className="mt-2 h3-para">
                By using this feature, your app can make intelligent decisions
                and suggest relevant content, becoming a tool that comprehends
                user needs and helps your audience. Our ML transforms your
                application from a basic tool into an intuitive digital
                companion, providing a highly valuable user journey.
              </p>
            </div>
          </>
        )}
      </div>
    </div>
  );
};

export default CoreComponent;
